import PathObject from "../objects/path"
import Form from "./base"
import { roundIncutPath } from "@/signomatic/util/shapes"

export default class RoundIncutForm extends Form {
  protected path(width: number) {
    return new PathObject(this.commands(width), this.defaultParams)
  }
  protected commands(width: number) {
    return roundIncutPath(width)
  }
}
